import { useApplicationState } from './application-context'
import { usePlanState } from './plan-context'

export function usePlanApplicationState() {
  const { isMigrated: isMigratedApplication } = useApplicationState()
  const { isMigratedPlan, hasEditPermission } = usePlanState()
  return { isMigratedPlan, isMigratedApplication, hasEditPermission }
}
